/* eslint-disable no-console */

// If you want to see detailed information in console about all BI, set to true
const IS_EXPAND_LOG = false;
export function logBI(_ref) {
  let {
    eventName,
    event,
    isDeprecated
  } = _ref;
  const output = JSON.stringify(event, null, 2).replace(/"/g, '');
  const deprecationMessage = isDeprecated ? '[deprecated logger] ' : '';
  const systemEventName = event.eventName ? "(" + event.eventName + ")" : '';
  const logMethod = IS_EXPAND_LOG ? 'group' : 'groupCollapsed';
  console[logMethod]("%c" + deprecationMessage + "%cBI %c" + eventName + systemEventName + ":" + event.evid, 'color: #f27052;', 'color: #65c888;', 'color: auto; font-weight: normal;');
  console.log(output);
  console.groupEnd();
}
//# sourceMappingURL=index.js.map